import moment from 'moment'

export type ItemOption = {
    value: number
    name: string
}

export type Weekday = {
    name: string
    enabled: boolean
    setEnabled?: (b: boolean) => void
    start: ItemOption | string
    setStart?: (s: ItemOption) => void
    end: ItemOption | string
    setEnd?: (e: ItemOption) => void
    endHours: ItemOption[]
    setEndHours?: (i: ItemOption[]) => void
}

export const createAvailabilityArrayV2 = (data: any): Weekday[] => {
    const itemHours: ItemOption[] = []
    for (let i = 0; i < 24; i++) {
        itemHours.push({ value: i, name: moment().hour(i).minute(0).format('h:mma') })
        itemHours.push({ value: i + 0.5, name: moment().hour(i).minute(30).format('h:mma') })
    }

    itemHours.push({ value: 24, name: moment().hour(0).minute(0).format('h:mma') })
    const weekdays: Weekday[] = []
    const dayKeys = [
        { start: 'monStartHour', end: 'monEndHour' },
        { start: 'tueStartHour', end: 'tueEndHour' },
        { start: 'wedStartHour', end: 'wedEndHour' },
        { start: 'thuStartHour', end: 'thuEndHour' },
        { start: 'friStartHour', end: 'friEndHour' },
        { start: 'satStartHour', end: 'satEndHour' },
        { start: 'sunStartHour', end: 'sunEndHour' },
    ]

    for (let i = 1; i <= 7; i++) {
        const keys = dayKeys[i - 1]
        const start =
            itemHours.find((i) => i.value.toFixed(1) === parseFloat(data[keys.start]).toFixed(1)) ||
            ''
        const end =
            itemHours.find((i) => i.value.toFixed(1) === parseFloat(data[keys.end]).toFixed(1)) ||
            ''
        const enabled = start !== '' && (data.schedule & (1 << (i - 1))) !== 0

        weekdays.push({
            name: moment().day(i).format('ddd'),
            enabled,
            start,
            end,
            endHours: [],
        })
    }

    return weekdays
}
